export default __webpack_public_path__ + "static/media/copy.b8f09a77.svg";